<div class="modal-header">
  <h4 class="modal-title pull-left">Create new process</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form (ngSubmit)="onSubmit()">
    <!-- <div class="form-group">
    <label for="exampleInputEmail1">Company</label>
    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Company">
    <small id="emailHelp" class="form-text text-muted">Small info.</small>
  </div> -->


  <div class="form-group">
    <label for="companies">{{'CONTROL-MODULE.SELECT_COMPANY' | translate}}</label>
    <ng-select
      name="companies"
      [items]="companies$ | async"
      bindLabel="fullName"
      [virtualScroll]="true"
      [minTermLength]="minLengthTerm"
      [loading]="companiesLoading"
      typeToSearchText="Please enter {{minLengthTerm}} or more characters" [typeahead]="companiesInput$"
      [(ngModel)]="selectedCompany"
      (change)="onCompanyChange()">

    </ng-select>
  </div>
  @if (needSelectControl) {
    <div class="form-group">
      <label for="controlTypes">{{'CONTROL-MODULE.SELECT_CONTROL' | translate}}</label>
      <ng-select
        [clearable]="false"
        name="controlTypes"
        [items]="controlTypes$"
        bindLabel="name"
        [virtualScroll]="true"
        [minTermLength]="minLengthTerm"
        [loading]="controlTypesLoading"
        typeToSearchText="Please enter {{minLengthTerm}} or more characters" [typeahead]="controlTypesInput$"
        [(ngModel)]="selectedControl">
      </ng-select>
    </div>
  }


  <div class="btn-toolbar mt-2" role="group" aria-label="Basic example">
    <button type="submit" class="btn btn-primary me-2"
    [disabled]="!this.selectedCompany || !this.selectedControl || creating">{{'CONTROL-MODULE.OK' | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="modalRef.hide()">{{'CONTROL-MODULE.CANCEL' | translate}}</button>
  </div>

</form>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="var(--fg-on-navy)" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white; text-align: center;">{{'UTIL.LOADING' | translate}}...</p>
</ngx-spinner>
